import { render, staticRenderFns } from "./Nivel1Requisitos.vue?vue&type=template&id=0c2b45b8&"
import script from "./Nivel1Requisitos.vue?vue&type=script&lang=js&"
export * from "./Nivel1Requisitos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports